"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var __1 = require("..");
var IconButton = react_1.forwardRef(function IconButton(_a, ref) {
    var loading = _a.loading, disabled = _a.disabled, children = _a.children, props = __rest(_a, ["loading", "disabled", "children"]);
    if (loading && disabled === undefined) {
        disabled = true;
    }
    if (loading) {
        children = jsx_runtime_1.jsx(__1.CircularProgress, { size: "1em", color: "inherit" }, void 0);
    }
    return (jsx_runtime_1.jsx(IconButton_1.default, __assign({ disabled: disabled }, props, { ref: ref }, { children: children }), void 0));
});
exports.default = IconButton;
//# sourceMappingURL=IconButton.js.map